import React, { Component } from "react";
import "./NewGrading.css";
import Logo from "../images/logoCropped.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faUser,
  faUsers,
  faCheck,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSpinnerThird,
  faUserDoctorMessage,
} from "@fortawesome/pro-solid-svg-icons";
import ActionLog from "./Components/ActionLog/ActionLog";
import logFetchError from "../Functions/LogFetchError";
import fetchSubmitLogs from "../Functions/FetchSubmitLogs";
import ViewCompletionsPopup from "./Components/ViewCompletionsPopup/ViewCompletionsPopup";
import { AnimatePresence, motion } from "framer-motion/dist/framer-motion";
import MDSpinner from "react-md-spinner";
import formatDateString from "../Functions/FormatDateString";
import formatTimeString from "../Functions/FormatTimeString";
import { Line } from "react-chartjs-2";

export default class NewGrading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedActionLogItem: 0,
      caseCompletionDate: null,
      reviewLater: this.props.reviewLater,
      highYield: false,
      selectedCaseData: {
        AvgGradeForCase: 0,
      },
      grading: this.props.grading
        ? this.props.grading
        : {
            GradeFeedback: {
              GradeOut: [],
            },
          },
      gradingSections: [
        {
          title: "Diagnosis Orders",
          gradeValue: "FinalDiagnoisGrade",
          weightValue: "WEIGHTDIAGNOSIS",
        },
        {
          title: "Treatment Orders",
          gradeValue: "FinalTreatmentGrade",
          weightValue: "WEIGHTTREATMENT",
        },
        {
          title: "Preventive care",
          gradeValue: "FinalPreventiveCareGrade",
          weightValue: "WEIGHTPREVENTATIVE",
        },
        {
          title: "Timing",
          gradeValue: "FinalTimingGrade",
          weightValue: "WEIGHTTIMING",
        },
        {
          title: "Appropriate Orders",
          gradeValue: "FinalAppropriateGrade",
          weightValue: "WEIGHTAPPROPRIATE",
        },
        {
          title: "Appropriate Location / Appropriate Sequence",
          gradeValue: "FinalSequenceGrade",
          weightValue: "WEIGHTSEQUENCING",
        },
      ],
      enableFeedbackGrading:
        props.gradingMode === "peek" ? false : !this.props.DisableFeedback,
      viewPreviousCompletions: false,
      previousCompletionSelected: 0,
      previousCompletions: [],
      highYieldLoading: false,
      reviewLaterLoading: false,
      showFeedbackModal: false,
      feedbackText: "",
      feedbackLoading: false,
      feedbackSubmitted: false,
      feedbackError: null,
      showReadingOptions: false,
      readingFontSize: "medium", // "small" | "medium" | "large" | "xlarge"
      readingFontFamily: "sans", // "sans" | "serif" | "mono"
      readingLineHeight: "normal", // "compact" | "normal" | "relaxed"
      readingLetterSpacing: "normal", // "normal" | "wide"
      readingColorScheme: "default", // "default" | "mono" | "sepia" | "cool" | "highcontrast"
    };
  }

  componentDidMount() {
    this.fetchReadingOptions();

    if (this.props.gradingMode === "peek") {
      this.fetchPeekCaseGrade();
    } else {
      this.fetchViewCaseGrade();
    }

    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute(
      "content",
      this.props.selectedTheme.tertiaryBackgroundColor,
    );
  }

  fetchReviewLater = () => {
    let caseId;
    if (this.props.caseGrades) {
      caseId = this.props.caseGrades;
    } else {
      caseId = this.props.selectedCase;
    }
    this.setState({ reviewLaterLoading: true });
    fetch(`${this.props.route}/reviewlater.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
        caseId: caseId,
        marked: !this.state.reviewLater,
      }),
    })
      .then((response) => {
        this.setState({ reviewLaterLoading: false });
        //Attempt sending logs
        fetchSubmitLogs(this.props.userProfile, this.props.userData);

        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((response) => {
        this.reviewLaterToggle();
      })
      .catch((error) => {
        this.setState({ reviewLaterLoading: false });
        // if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
        // 	this.props.setAuthenticationError()
        // }
        console.log(error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchReviewLater",
        );
      });
  };

  reviewLaterToggle = () => {
    this.setState({ reviewLater: !this.state.reviewLater }, () => {
      this.props.updateReviewLater();
    });
  };

  submitFeedback = () => {
    if (!this.state.feedbackText.trim()) {
      return;
    }

    this.setState({ feedbackLoading: true, feedbackError: null });

    const caseId = this.state.grading?.CaseId ?? null;
    const caseDiagnosis =
      this.state.grading?.GradeFeedback?.FinalDiagnosis ?? null;

    const feedbackPayload = {
      customerId: this.props.userData.CustomerId,
      feedback: this.state.feedbackText,
      ...(caseId !== null && { caseId }),
      ...(caseDiagnosis !== null && { caseDiagnosis }),
    };

    fetch("https://app.ccscases.com/feedback.webapi", {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify(feedbackPayload),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        }
        return response.text();
      })
      .then((response) => {
        this.setState({
          feedbackLoading: false,
          feedbackSubmitted: true,
          feedbackText: "",
        });
        setTimeout(() => {
          this.setState({
            showFeedbackModal: false,
            feedbackSubmitted: false,
          });
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          feedbackLoading: false,
          feedbackError: "Failed to submit feedback. Please try again.",
        });
        console.log(error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "submitFeedback",
        );
      });
  };

  closeFeedbackModal = () => {
    this.setState({
      showFeedbackModal: false,
      feedbackText: "",
      feedbackSubmitted: false,
      feedbackError: null,
    });
  };

  getDateSuffix = (day) => {
    if (day === 1 || day === 21 || day === 31) {
      return "st";
    } else if (day === 2 || day === 22) {
      return "nd";
    } else if (day === 3 || day === 23) {
      return "rd";
    } else {
      return "th";
    }
  };

  formatCompletionDate = (unformattedDate) => {
    let dateObject = new Date(unformattedDate);

    // Format the date as Aug 1st, 2021, 10:37 PM
    const MONTHS = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let month = MONTHS[dateObject.getMonth()];
    let day = dateObject.getDate();
    let daySuffix = this.getDateSuffix(day);
    let year = dateObject.getFullYear();
    let hours = dateObject.getHours();
    let minutes = dateObject.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let formattedDate =
      month +
      " " +
      day +
      daySuffix +
      ", " +
      year +
      ", " +
      hours +
      ":" +
      minutes +
      " " +
      ampm;
    return formattedDate;
  };

  fetchRetrieveCaseGrade = async (id) => {
    await fetch(`${this.props.route}/retreivecasegrade.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        CustomerGradeId: id,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((data) => {
        //Attempt sending logs
        fetchSubmitLogs(this.props.userProfile, this.props.userData);

        data = JSON.parse(data);

        // Get caseData from the unfiltered case list
        let caseData = this.props.unfilteredCaseList.filter(
          (tempCase) => tempCase.ID === this.props.selectedCase,
        )[0];

        // sort by GradeCategory
        data.GradeFeedback.GradeOut.sort((a, b) => {
          if (a.GradeCategory < b.GradeCategory) {
            return -1;
          } else if (a.GradeCategory > b.GradeCategory) {
            return 1;
          } else {
            return 0;
          }
        });
        data.GradeFeedback.GradeOut = data.GradeFeedback.GradeOut.filter(
          (grade) => grade.GradeCategory !== "",
        );

        for (let i = 0; i < data.GradeFeedback.GradeOut.length; i++) {
          if (
            data.GradeFeedback.GradeOut[i].GradeColor.includes(
              "Correct - Green",
            )
          ) {
            data.GradeFeedback.GradeOut[i].Correct = true;
          } else {
            data.GradeFeedback.GradeOut[i].Correct = false;
          }
        }

        for (let i = 0; i < data.GradeFeedback.ActionLogList.length; ++i) {
          if (
            data.GradeFeedback.ActionLogList[i].EventName.includes(
              "State Changed to:",
            )
          ) {
            data.GradeFeedback.ActionLogList.splice(i, 1);
            i--;
          }
        }
        console.log("grabbing data", data);
        this.setState({
          selectedCase: id,
          selectedCaseData: caseData,
          caseCompletionDate: data.CaseCompletionDate,
          caseGradeData: data,
          grading: data,
          highYield: data.HighYieldFlag,
          AverageOrders: data.GradeFeedback.AverageOrders,
        });
      })
      .catch((error) => {
        // if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
        // 	this.props.setAuthenticationError()
        // }
        console.log("error", error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchRetrieveCaseGrade",
        );
      });
  };

  fetchPeekCaseGrade = () => {
    let caseId = this.props.selectedCase;
    fetch(`${this.props.route}/peekatgrading.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
        caseId: caseId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((data) => {
        if (
          data.includes(
            "The customer has already done this case. The customer should use View Grades instead.",
          )
        ) {
          return;
        }
        data = JSON.parse(data);
        let grading = {
          GradeFeedback: data,
        };

        let caseData = this.props.unfilteredCaseList.filter(
          (tempCase) => tempCase.ID === this.props.selectedCase,
        )[0];

        this.setState({
          caseCompletionDate: data.CompletionDate,
          selectedCase: caseId,
          grading,
          selectedCaseData: caseData,
        });
      })
      .catch((error) => {
        console.log("error", error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchPeekCaseGrade",
        );
      });
  };

  fetchReadingOptions = () => {
    fetch(`${this.props.route}/getsavedreadingoptions.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((data) => {
        data = JSON.parse(data);

        console.log("Got reading options", data);
        this.setState({
          ...(data.readingFontSize && {
            readingFontSize: data.readingFontSize,
          }),
          ...(data.readingFontFamily && {
            readingFontFamily: data.readingFontFamily,
          }),
          ...(data.readingLineHeight && {
            readingLineHeight: data.readingLineHeight,
          }),
          ...(data.readingLetterSpacing && {
            readingLetterSpacing: data.readingLetterSpacing,
          }),
          ...(data.readingColorScheme && {
            readingColorScheme: data.readingColorScheme,
          }),
        });
      })
      .catch((error) => {
        console.log("error", error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchReadingOptions",
        );
      });
  };

  fetchViewCaseGrade = () => {
    let caseId;
    if (this.props.caseGrades) {
      caseId = this.props.caseGrades;
    } else {
      caseId = this.props.selectedCase;
    }
    fetch(`${this.props.route}/viewcasegrade.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
        caseId: caseId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((response) => {
        //Attempt sending logs
        fetchSubmitLogs(this.props.userProfile, this.props.userData);

        let data = response;
        // reverse order of array
        let array = JSON.parse(data).vcgo;
        array.reverse();

        let caseArray = []; // only display the cases that are of the case selected
        for (let i = 0; i < array.length; i++) {
          if (
            array[i].CaseId === caseId &&
            array[i].CaseCompletionDate !== "January 1, 1, 0:00"
          ) {
            caseArray.push(array[i]);
          }
        }

        let newCaseArray = [...caseArray];

        // sort newCaseArray by CaseCompletionDate
        newCaseArray.sort((a, b) => {
          return (
            new Date(b.CaseCompletionDate) - new Date(a.CaseCompletionDate)
          );
        });

        // if !this.props.grading fetch data for most recent case
        if (!this.props.grading) {
          this.fetchRetrieveCaseGrade(newCaseArray[0].CustomerGradeId);
        }

        this.setState({
          previousCompletions: newCaseArray,
          selectedCase: newCaseArray[0].CustomerGradeId,
        });
      })
      .catch((error) => {
        // if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
        // 	this.props.setAuthenticationError()
        // }
        console.log(error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchViewCaseGrade",
        );
      });
  };

  // enableFeedbackGrading = () => {
  // 	this.setState({enableFeedbackGrading: !this.state.enableFeedbackGrading});
  // }

  markHighYieldHandler = () => {
    let caseId;
    if (this.props.caseGrades) {
      caseId = this.props.caseGrades;
    } else {
      caseId = this.props.selectedCase;
    }
    this.setState(
      { highYield: !this.state.highYield, highYieldLoading: true },
      () => {
        fetch(`${this.props.route}/highyield.webapi`, {
          method: "POST",
          headers: {
            Token: this.props.userData.Token,
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            customerid: this.props.userData.CustomerId,
            caseid: caseId,
            markhighyield: this.state.highYield,
            unmarkhighyield: !this.state.highYield,
          }),
        })
          .then((response) => {
            this.setState({ highYieldLoading: false });
            //Attempt sending logs
            fetchSubmitLogs(this.props.userProfile, this.props.userData);

            if (response.status === 401) {
              this.props.setAuthenticationError();
              throw new Error("Authentication Error");
            } else {
              return response.text();
            }
          })
          .then((response) => {})
          .catch((error) => {
            this.setState({
              highYield: !this.state.highYield,
              highYieldLoading: false,
            });
            logFetchError(
              error,
              this.props.userProfile,
              this.props.userData,
              "markHighYieldHandler",
            );
          });
      },
    );
  };

  highYieldHelpHandler = (e) => {
    e.stopPropagation();
    let confirmationPopupOptions = {
      title: `High Yield`,
      description: `If you think this case has a good chance to show up on the USMLE Step 3 exam, you can mark it as High Yield. This helps other users know which cases to study.`,
      confirmFunction: async () => {
        this.props.closeConfirmationPopup();
      },
      children: null,
      closePopup: () => {
        this.props.closeConfirmationPopup();
      },
      continueOnly: true,
    };
    this.props.displayConfirmationPopup(confirmationPopupOptions);
  };

  getAverageOrdersChartData = () => {
    const { AverageOrders } = this.state;
    const averageOrders = AverageOrders.AverageOrders;
    const userOrders = AverageOrders?.NumberOrders
      ? AverageOrders?.NumberOrders
      : 0;
    const average85Above = averageOrders.average_num_orders_85_above;
    const stdDev = averageOrders.std_dev_orders_85_above;

    // Create a normal distribution curve around the average
    const dataPoints = [];
    const labels = [];

    // Generate points for the distribution curve (3 standard deviations on each side)
    const minX = Math.max(0, average85Above - 3 * stdDev);
    const maxX = average85Above + 3 * stdDev;
    const step = (maxX - minX) / 50; // 50 points for smooth curve

    for (let x = minX; x <= maxX; x += step) {
      labels.push(Math.round(x));
      // Normal distribution formula
      const exponent = -0.5 * Math.pow((x - average85Above) / stdDev, 2);
      const y = (1 / (stdDev * Math.sqrt(2 * Math.PI))) * Math.exp(exponent);
      dataPoints.push(y);
    }

    // Find the user's position on the curve
    const userPosition = Math.max(
      0,
      Math.min(labels.length - 1, Math.round((userOrders - minX) / step)),
    );

    // Create datasets
    const datasets = [
      {
        label: "Distribution of Orders (>85% scores)",
        data: dataPoints,
        borderColor: "#4F46E5",
        backgroundColor: "rgba(79, 70, 229, 0.1)",
        fill: true,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "Your Performance",
        data: labels.map((_, index) =>
          index === userPosition ? dataPoints[userPosition] : null,
        ),
        borderColor: AverageOrders.Color === "Green" ? "#10B981" : "#EF4444",
        backgroundColor:
          AverageOrders.Color === "Green" ? "#10B981" : "#EF4444",
        pointRadius: 8,
        pointHoverRadius: 10,
        showLine: false,
      },
    ];

    return {
      labels,
      datasets,
    };
  };

  getAverageOrdersChartOptions = () => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: "Order Count Distribution (First Attempts >85%)",
          color: "#374151",
          font: {
            size: 14,
            weight: "bold",
          },
        },
        legend: {
          display: true,
          position: "top",
          labels: {
            color: "#374151",
            usePointStyle: true,
          },
        },
        tooltip: {
          mode: "index",
          intersect: false,
          callbacks: {
            title: function (context) {
              return `Orders: ${context[0].label}`;
            },
            label: function (context) {
              if (context.datasetIndex === 0) {
                return `Probability Density: ${context.parsed.y.toFixed(4)}`;
              } else {
                return `Your Position (Z-score: ${this.state.AverageOrders.Zscore.toFixed(
                  2,
                )})`;
              }
            }.bind(this),
          },
        },
      },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: "Number of Orders",
            color: "#374151",
            font: {
              weight: "bold",
            },
          },
          grid: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          ticks: {
            color: "#6B7280",
            callback: function (value, index, values) {
              // Show every 5th tick to avoid crowding
              if (index % 5 === 0) {
                return this.getLabelForValue(value);
              }
              return "";
            },
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: "Probability Density",
            color: "#374151",
            font: {
              weight: "bold",
            },
          },
          grid: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          ticks: {
            color: "#6B7280",
            callback: function (value) {
              return value.toFixed(3);
            },
          },
        },
      },
      interaction: {
        mode: "nearest",
        axis: "x",
        intersect: false,
      },
    };
  };

  getReadingStyle = (verdict = "neutral") => {
    const fontSizeMap = {
      small: "13px",
      medium: "15px",
      large: "17px",
      xlarge: "20px",
    };
    const fontFamilyMap = {
      sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      serif: "Georgia, 'Times New Roman', serif",
      mono: "'Courier New', Courier, monospace",
    };
    const lineHeightMap = { compact: "1.4", normal: "1.7", relaxed: "2.1" };
    const letterSpacingMap = { normal: "0px", wide: "0.04em" };

    // Color scheme overrides keyed by [scheme][verdict] → { background, color }
    const colorSchemes = {
      default: {}, // no overrides — let CSS classes handle it
      mono: {
        correct: { backgroundColor: "#f0f0f0", color: "#1a1a1a" },
        incorrect: { backgroundColor: "#8a8a8a", color: "#f5f5f5" },
        optional: { backgroundColor: "#cbcbcb", color: "#1a1a1a" },
        neutral: { backgroundColor: "#e0e0e0", color: "#1a1a1a" },
      },
      sepia: {
        correct: { backgroundColor: "#f0e8cf", color: "#3b2f14" },
        incorrect: { backgroundColor: "#b89a70", color: "#2a1f0a" },
        optional: { backgroundColor: "#ddd0b0", color: "#3b2f14" },
        neutral: { backgroundColor: "#ede5cc", color: "#3b2f14" },
      },
      cool: {
        correct: { backgroundColor: "#e8f4fc", color: "#0d2a3a" },
        incorrect: { backgroundColor: "#7aafd4", color: "#0d1e2e" },
        optional: { backgroundColor: "#c0daf0", color: "#0d2a3a" },
        neutral: { backgroundColor: "#daeaf7", color: "#0d2a3a" },
      },
      highcontrast: {
        correct: { backgroundColor: "#003300", color: "#ccffcc" },
        incorrect: { backgroundColor: "#330000", color: "#ffcccc" },
        optional: { backgroundColor: "#1a1a00", color: "#ffffcc" },
        neutral: { backgroundColor: "#00134d", color: "#cce0ff" },
      },
    };

    const colorOverride =
      colorSchemes[this.state.readingColorScheme]?.[verdict] ?? {};

    return {
      fontSize: fontSizeMap[this.state.readingFontSize],
      fontFamily: fontFamilyMap[this.state.readingFontFamily],
      lineHeight: lineHeightMap[this.state.readingLineHeight],
      letterSpacing: letterSpacingMap[this.state.readingLetterSpacing],
      ...colorOverride,
    };
  };

  saveReadingOptions = async () => {
    try {
      const response = await fetch(
        `${this.props.route}/savereadingoptions.webapi`,
        {
          method: "POST",
          headers: {
            Token: this.props.userData.Token,
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            customerId: this.props.userData.CustomerId,
            readingFontSize: this.state.readingFontSize,
            readingFontFamily: this.state.readingFontFamily,
            readingLineHeight: this.state.readingLineHeight,
            readingLetterSpacing: this.state.readingLetterSpacing,
            readingColorScheme: this.state.readingColorScheme,
          }),
        },
      );

      if (response.status === 401) {
        this.props.setAuthenticationError();
        throw new Error("Authentication Error");
      }

      const data = JSON.parse(await response.text());
      console.log("saved reading options", data);
    } catch (error) {
      console.log("error", error);
      logFetchError(
        error,
        this.props.userProfile,
        this.props.userData,
        "savereadingoptions",
      );
    }
  };

  render() {
    return (
      <div className="newGradingPageWrapper">
        <nav className="newGradingNavbar">
          <img className="newGradingLogo" alt="CCS Cases Logo" src={Logo} />
        </nav>
        <AnimatePresence exitBeforeEnter>
          {this.state.grading.GradeFeedback.GradeOut.length === 0 && (
            <motion.div
              className="newGradingLoaderContainer"
              initial={this.props.animationsDisabled ? false : { opacity: 0 }}
              animate={
                this.props.animationsDisabled ? false : { y: 0, opacity: 1 }
              }
              exit={this.props.animationsDisabled ? false : { opacity: 0 }}
              transition={{ duration: 0.2 }}
              key="newGradingLoaderContainer"
            >
              <MDSpinner size={60} singleColor={this.props.primaryColor} />
              <p className="newGradingLoaderText">Loading Grades</p>
            </motion.div>
          )}
          {this.state.grading.GradeFeedback.GradeOut.length > 0 && (
            <motion.div
              className="newGradingBackWrapper"
              initial={this.props.animationsDisabled ? false : { opacity: 0 }}
              animate={this.props.animationsDisabled ? false : { opacity: 1 }}
              exit={this.props.animationsDisabled ? false : { opacity: 0 }}
              transition={{ duration: 0.2 }}
              key="newGradingBackWrapper"
            >
              <button
                className="tertiaryButton newGradingBackButton"
                onClick={async () => {
                  await this.saveReadingOptions();
                  this.props.closeGrading();
                }}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="newGradingBackIcon"
                />
                Back To Case List
              </button>
              {this.props.gradingMode !== "peek" &&
                this.state.grading.GradeFeedback.ActionLogList.length > 0 && (
                  <div
                    className="newGradingCheckboxContainer"
                    onClick={this.markHighYieldHandler}
                    style={{
                      gridTemplateColumns: "30px auto auto",
                      paddingRight: "10px",
                    }}
                  >
                    <div className="newGradingCheckbox">
                      {this.state.highYield && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="newGradingCheckboxIcon"
                        />
                      )}
                    </div>
                    <p className="newGradingCheckboxText">High Yield</p>
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="highYieldMoreInfoButton"
                      onClick={this.highYieldHelpHandler}
                    />
                    {this.state.highYieldLoading && (
                      <div className="highYieldLoadingContainer">
                        <MDSpinner size={35} singleColor={"#fff"} />
                      </div>
                    )}
                  </div>
                )}
              <div
                className="newGradingCheckboxContainer"
                onClick={this.fetchReviewLater}
                style={{ gridTemplateColumns: "30px auto" }}
              >
                <div className="newGradingCheckbox">
                  {this.state.reviewLater && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="newGradingCheckboxIcon"
                    />
                  )}
                </div>
                <p className="newGradingCheckboxText">Review Later</p>
                {this.state.reviewLaterLoading && (
                  <div className="highYieldLoadingContainer">
                    <MDSpinner size={30} singleColor={"#fff"} />
                  </div>
                )}
              </div>
            </motion.div>
          )}
          {this.state.grading.GradeFeedback.GradeOut.length > 0 && (
            <motion.div
              className="newGradingCaseTitleContainer"
              initial={this.props.animationsDisabled ? false : { opacity: 0 }}
              animate={this.props.animationsDisabled ? false : { opacity: 1 }}
              exit={this.props.animationsDisabled ? false : { opacity: 0 }}
              transition={{ duration: 0.2 }}
              key="newGradingCaseTitleContainer"
            >
              <div className="newGradingCaseNumberContainer">
                <h1 className="newGradingCaseNumber">
                  {this.state.selectedCaseData.ID}
                </h1>
              </div>
              <div className="newGradingCaseTitleWrapper">
                <h2 className="newGradingCaseTitle">
                  {this.state.selectedCaseData.TITLE} -{" "}
                  {this.state.selectedCaseData.CASECATEGORYDESC}
                </h2>
                <h3 className="newGradingCaseCompletionDate">
                  Completed:{" "}
                  {formatDateString(
                    this.state.caseCompletionDate,
                    this.props.userData.TimeZone,
                  )}
                  ,{" "}
                  {formatTimeString(
                    this.state.caseCompletionDate,
                    this.props.userData.TimeZone,
                  )}
                </h3>
              </div>
              <div className="grading-button-block">
                {this.props.gradingMode !== "peek" &&
                  this.props.hideFeedbackInGrading == false && (
                    <button
                      className="newGradingViewPreviousButton tertiaryButton"
                      onClick={() => this.setState({ showFeedbackModal: true })}
                    >
                      Feedback
                    </button>
                  )}
                {this.props.gradingMode !== "peek" && (
                  <button
                    className="newGradingViewPreviousButton tertiaryButton"
                    onClick={() =>
                      this.setState({ viewPreviousCompletions: true })
                    }
                  >
                    View Previous Completions
                  </button>
                )}
                <div className="readingOptionsWrapper">
                  <button
                    className="newGradingViewPreviousButton tertiaryButton readingOptionsToggle"
                    onClick={() =>
                      this.setState((s) => ({
                        showReadingOptions: !s.showReadingOptions,
                      }))
                    }
                  >
                    <span className="readingOptionsIcon">Aa</span>
                    <span className="readingOptionsText">Reading Options</span>
                  </button>
                  {this.state.showReadingOptions && (
                    <>
                      <div
                        className="readingOptionsBackdrop"
                        onClick={() =>
                          this.setState({ showReadingOptions: false })
                        }
                      />
                      <div
                        className="readingOptionsPanel"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="readingOptionsSection">
                          <span className="readingOptionsLabel">Font Size</span>
                          <div className="readingOptionsRow">
                            {[
                              { key: "small", label: "S" },
                              { key: "medium", label: "M" },
                              { key: "large", label: "L" },
                              { key: "xlarge", label: "XL" },
                            ].map(({ key, label }) => (
                              <button
                                key={key}
                                className={`readingOptionChip ${this.state.readingFontSize === key ? "readingOptionChipActive" : ""}`}
                                onClick={() =>
                                  this.setState({ readingFontSize: key })
                                }
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="readingOptionsSection">
                          <span className="readingOptionsLabel">Typeface</span>
                          <div className="readingOptionsRow">
                            {[
                              { key: "sans", label: "Sans" },
                              { key: "serif", label: "Serif" },
                              { key: "mono", label: "Mono" },
                            ].map(({ key, label }) => (
                              <button
                                key={key}
                                className={`readingOptionChip ${this.state.readingFontFamily === key ? "readingOptionChipActive" : ""}`}
                                onClick={() =>
                                  this.setState({ readingFontFamily: key })
                                }
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="readingOptionsSection">
                          <span className="readingOptionsLabel">
                            Line Spacing
                          </span>
                          <div className="readingOptionsRow">
                            {[
                              { key: "compact", label: "Compact" },
                              { key: "normal", label: "Normal" },
                              { key: "relaxed", label: "Relaxed" },
                            ].map(({ key, label }) => (
                              <button
                                key={key}
                                className={`readingOptionChip ${this.state.readingLineHeight === key ? "readingOptionChipActive" : ""}`}
                                onClick={() =>
                                  this.setState({ readingLineHeight: key })
                                }
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="readingOptionsSection">
                          <span className="readingOptionsLabel">
                            Letter Spacing
                          </span>
                          <div className="readingOptionsRow">
                            {[
                              { key: "normal", label: "Normal" },
                              { key: "wide", label: "Wide" },
                            ].map(({ key, label }) => (
                              <button
                                key={key}
                                className={`readingOptionChip ${this.state.readingLetterSpacing === key ? "readingOptionChipActive" : ""}`}
                                onClick={() =>
                                  this.setState({ readingLetterSpacing: key })
                                }
                              >
                                {label}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="readingOptionsSection">
                          <span className="readingOptionsLabel">
                            Color Scheme
                          </span>
                          <div className="readingOptionsColorRow">
                            {[
                              {
                                key: "default",
                                label: "Default",
                                swatches: ["#e2ffdd", "#ffdddd", "#d1ecf1"],
                              },
                              {
                                key: "mono",
                                label: "Mono",
                                swatches: ["#f0f0f0", "#8a8a8a", "#cbcbcb"],
                              },
                              {
                                key: "sepia",
                                label: "Sepia",
                                swatches: ["#f0e8cf", "#b89a70", "#ddd0b0"],
                              },
                              {
                                key: "cool",
                                label: "Cool",
                                swatches: ["#e8f4fc", "#7aafd4", "#c0daf0"],
                              },
                              {
                                key: "highcontrast",
                                label: "High Contrast",
                                swatches: ["#003300", "#330000", "#00134d"],
                              },
                            ].map(({ key, label, swatches }) => (
                              <button
                                key={key}
                                className={`readingColorChip ${this.state.readingColorScheme === key ? "readingColorChipActive" : ""}`}
                                onClick={() =>
                                  this.setState({ readingColorScheme: key })
                                }
                                title={label}
                              >
                                <span className="readingColorSwatches">
                                  {swatches.map((bg, i) => (
                                    <span
                                      key={i}
                                      className="readingColorSwatch"
                                      style={{ backgroundColor: bg }}
                                    />
                                  ))}
                                </span>
                                <span className="readingColorLabel">
                                  {label}
                                </span>
                              </button>
                            ))}
                          </div>
                        </div>

                        <button
                          className="readingOptionsReset"
                          onClick={() =>
                            this.setState(
                              {
                                readingFontSize: "medium",
                                readingFontFamily: "sans",
                                readingLineHeight: "normal",
                                readingLetterSpacing: "normal",
                                readingColorScheme: "default",
                              },
                              this.saveReadingOptions,
                            )
                          }
                        >
                          Reset to defaults
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </motion.div>
          )}
          {this.state.grading.GradeFeedback.GradeOut.length > 0 && (
            <motion.div
              className="newGradingCaseDetailsWrapper"
              initial={this.props.animationsDisabled ? false : { opacity: 0 }}
              animate={this.props.animationsDisabled ? false : { opacity: 1 }}
              exit={this.props.animationsDisabled ? false : { opacity: 0 }}
              transition={{ duration: 0.2 }}
              key="newGradingCaseDetailsWrapper"
            >
              <div className="newGradingCaseDetailContainer">
                <div className="newGradingCaseDetailIconContainer">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="newGradingCaseDetailIcon"
                  />
                </div>
                <h3 className="newGradingCaseDetailTitle">Your Score</h3>
                <h2 className="newGradingCaseDetailValue">
                  {this.props.gradingMode === "peek"
                    ? this.state.grading.GradeFeedback.TotalGrade
                    : this.state.grading.GradeForCase}
                  %
                </h2>
              </div>

              <div className="newGradingCaseDetailContainer">
                <div className="newGradingCaseDetailIconContainer">
                  <FontAwesomeIcon
                    icon={faUsers}
                    className="newGradingCaseDetailIcon"
                  />
                </div>
                <h3 className="newGradingCaseDetailTitle">
                  Average First Attempt Score
                </h3>
                <h2 className="newGradingCaseDetailValue">
                  {this.props.gradingMode === "peek"
                    ? this.state.grading.GradeFeedback.AverageFirstAttempt.toFixed(
                        1,
                      )
                    : this.state.grading.AverageFirstAttempt.toFixed(1)}
                  %
                </h2>
              </div>

              <div className="newGradingCaseDetailContainer">
                <div className="newGradingCaseDetailIconContainer">
                  <FontAwesomeIcon
                    icon={faUserDoctorMessage}
                    className="newGradingCaseDetailIcon"
                  />
                </div>
                <h3 className="newGradingCaseDetailTitle">Case Diagnosis</h3>
                <h2 className="newGradingCaseDetailValue">
                  {this.state.grading.GradeFeedback.FinalDiagnosis}
                </h2>
              </div>
            </motion.div>
          )}
          {/* {this.state.grading.GradeFeedback.GradeOut.length > 0 &&
                        <motion.div
                            className='newGradingFeedbackTitleContainer'
                            initial={this.props.animationsDisabled ? false : {opacity: 0}}
                            animate={this.props.animationsDisabled ? false : {opacity: 1}}
                            exit={this.props.animationsDisabled ? false : {opacity: 0}}
                            transition={{duration: 0.2}}
                            key="newGradingFeedbackTitleContainer"
                        >
                            <h2 className='newGradingFeedbackTitle'>Grading Feedback</h2>
                            {this.props.gradingMode !== 'peek' &&
                                <div className='newGradingFeedbackCheckboxContainer' onClick={() => this.setState({enableFeedbackGrading: !this.state.enableFeedbackGrading})}>
                                    <div className='newGradingCheckbox'>
                                        {!this.state.enableFeedbackGrading && <FontAwesomeIcon icon={faCheck} className='newGradingCheckboxIcon'/>}
                                    </div>
                                    <p className='newGradingCheckboxText'>
                                        Disable Feedback
                                    </p>
                                </div>
                            }
                        </motion.div>
                    } */}
          {this.state.grading.GradeFeedback.GradeOut.length > 0 &&
            this.state.gradingSections.map(
              (section, sectionIndex) =>
                this.state.grading.GradeFeedback.GradeOut.some((feedback) =>
                  section.title.includes(feedback.GradeCategory),
                ) && (
                  <motion.div
                    className="newGradingFeedbackItemContainer"
                    initial={
                      this.props.animationsDisabled ? false : { opacity: 0 }
                    }
                    animate={
                      this.props.animationsDisabled ? false : { opacity: 1 }
                    }
                    exit={
                      this.props.animationsDisabled ? false : { opacity: 0 }
                    }
                    transition={{ duration: 0.2 }}
                    key={`newGradingFeedbackItemContainer - ${sectionIndex}`}
                  >
                    <h2 className="newGradingFeedbackItemTitle">
                      {section.title}:{" "}
                      {this.state.grading.GradeFeedback[section.gradeValue]
                        ? this.state.grading.GradeFeedback[section.gradeValue]
                        : 0}
                      %
                    </h2>
                    <h3 className="newGradingFeedbackItemValue">
                      Weight given for total score:{" "}
                      {this.state.grading.GradeFeedback[section.weightValue]}%
                    </h3>
                    <div className="newGradingFeedbackItemContentWrapper">
                      {this.state.grading.GradeFeedback.GradeOut.map(
                        (feedback, index) =>
                          section.title.includes(feedback.GradeCategory) && (
                            <div
                              key={`GradingFeedback - ${sectionIndex} - ${index}`}
                              className={`newGradingFeedbackAnswerWrapper ${
                                !this.state.enableFeedbackGrading
                                  ? "newGradingFeedbackAnswerNeutral"
                                  : feedback.Correct
                                    ? "newGradingFeedbackAnswerCorrect"
                                    : feedback.EventName.includes(
                                          "Optional Order",
                                        )
                                      ? "newGradingFeedbackAnswerNeutral"
                                      : "newGradingFeedbackAnswerIncorrect"
                              }`}
                              style={this.getReadingStyle(
                                !this.state.enableFeedbackGrading
                                  ? "neutral"
                                  : feedback.Correct
                                    ? "correct"
                                    : feedback.EventName.includes(
                                          "Optional Order",
                                        )
                                      ? "optional"
                                      : "incorrect",
                              )}
                            >
                              <h4
                                className="newGradingFeedbackAnswerTitle"
                                style={{
                                  marginBottom:
                                    !feedback.OrderNames &&
                                    !feedback.GradeExplanation
                                      ? "0px"
                                      : "15px",
                                }}
                              >
                                {(feedback.EventName.includes(
                                  "Correctly Ordered",
                                ) ||
                                  feedback.EventName.includes(
                                    "Should have Ordered",
                                  )) &&
                                !this.state.enableFeedbackGrading
                                  ? "Suggested Order"
                                  : feedback.EventName}
                              </h4>
                              {feedback.OrderNames &&
                                feedback.OrderNamesList.length === 0 && (
                                  <ul className="newGradingFeedbackAnswerItemList">
                                    <li className="newGradingFeedbackAnswerItem">
                                      {feedback.OrderNames}
                                    </li>
                                  </ul>
                                )}
                              {feedback.OrderNamesList.length !== 0 && (
                                <ul className="newGradingFeedbackAnswerItemList">
                                  <li className="newGradingFeedbackAnswerItem">
                                    {feedback.OrderNamesList.map(
                                      (orderName, orderNameIndex) =>
                                        orderName +
                                        (orderNameIndex !==
                                        feedback.OrderNamesList.length - 1
                                          ? " / "
                                          : ""),
                                    )}
                                  </li>
                                </ul>
                              )}
                              {feedback.GradeExplanation && (
                                <p className="newGradingFeedbackReason">
                                  <strong>Reason: </strong>
                                  {feedback.GradeExplanation}
                                </p>
                              )}
                            </div>
                          ),
                      )}
                    </div>
                  </motion.div>
                ),
            )}
          {this.state.grading.GradeFeedback.SUMMARY && (
            <motion.div
              className="newGradingCaseSummaryContainer"
              initial={this.props.animationsDisabled ? false : { opacity: 0 }}
              animate={this.props.animationsDisabled ? false : { opacity: 1 }}
              exit={this.props.animationsDisabled ? false : { opacity: 0 }}
              transition={{ duration: 0.2 }}
              key="newGradingCaseSummaryContainer"
              style={this.getReadingStyle()}
            >
              <h2
                className="newGradingCaseSummaryTitle"
                style={{ color: "inherit" }}
              >
                Case Summary
              </h2>
              <p
                className="newGradingCaseSummaryText"
                style={{ color: "inherit" }}
              >
                {this.state.grading.GradeFeedback.SUMMARY}
              </p>
            </motion.div>
          )}
          {this.state.grading &&
            this.state.AverageOrders &&
            this.state.AverageOrders.AverageOrders &&
            Object.keys(this.state.AverageOrders.AverageOrders).length > 0 && (
              <motion.div
                className="newGradingCaseSummaryContainer"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingCaseSummaryContainer"
              >
                <h2 className="newGradingCaseSummaryTitle">Average Orders</h2>
                <div>
                  <div className="averageOrdersContainer">
                    <div className="averageOrdersLeftContainer">
                      <div>
                        {`Number of orders you ordered for this case: `}
                        <span className="gradeNumber">
                          {this.state.AverageOrders?.NumberOrders || 0}
                        </span>
                      </div>
                      <div>
                        {`All users' average orders for first case attempt >85%: `}
                        <span className="gradeNumber">
                          {
                            this.state.AverageOrders.AverageOrders
                              .average_num_orders_85_above
                          }
                        </span>
                        {` orders`}
                      </div>
                      <div>
                        <span className="gradeNumber">
                          {
                            this.state.AverageOrders.AverageOrders
                              .average_num_orders_85_above
                          }
                        </span>
                        {`  is the average number of orders of users that scored 85% or greater on this case. `}
                      </div>
                      {false && (
                        <div>
                          {`All User's Standard Deviation on First Case Attempt >85%:`}{" "}
                          <span className="gradeNumber">
                            {
                              this.state.AverageOrders.AverageOrders
                                .std_dev_orders_85_above
                            }
                          </span>
                          {` orders`}
                          <div>
                            <span className="gradeNumber">
                              {
                                this.state.AverageOrders.AverageOrders
                                  .average_num_orders_85_above
                              }
                            </span>
                            {`  is the standard deviation of orders of users that scored 85% or greater on this case. `}
                          </div>
                        </div>
                      )}
                      <div>
                        {`Your Z-score: `}
                        <span className="gradeNumber">
                          {this.state.AverageOrders.Zscore.toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="averageOrdersLeftContainer">
                      <div
                        className="averageOrdersChartContainer"
                        style={{
                          height: "300px",
                          width: "100%",
                          maxWidth: "800px",
                          marginTop: "20px",
                        }}
                      >
                        <Line
                          data={this.getAverageOrdersChartData()}
                          options={this.getAverageOrdersChartOptions()}
                        />
                      </div>
                      <span
                        style={{
                          color: this.state.AverageOrders.Color,
                          textAlign: "center",
                        }}
                      >
                        {`${this.state.AverageOrders.Interpretation}. The curve shows how common each order count is among users scoring >85% on first attempts; the area under the curve totals 100%`}
                      </span>
                    </div>
                  </div>
                  <div className="disclaimer">
                    There’s no evidence that the USMLE penalizes users for
                    non-graded orders (except for medication, invasive orders,
                    and certain radiological studies). However, excessive
                    ordering to manipulate the system may incur penalties.
                    Currently, your score isn’t penalized for exceeding the
                    average number of orders by more than one standard
                    deviation, but we suggest keeping your order count within
                    the typical range of the average user.
                  </div>
                </div>
              </motion.div>
            )}
          {this.state.grading.GradeFeedback.ActionLogList &&
            this.props.gradingMode !== "peek" &&
            this.state.grading.GradeFeedback.ActionLogList.length > 0 && (
              <ActionLog
                actionLog={this.state.grading.GradeFeedback.ActionLogList}
                selectedActionLogItem={this.state.selectedActionLogItem}
                key="actionLogComponent"
                updateSelectedActionLogItem={(newSelection) =>
                  this.setState({ selectedActionLogItem: newSelection })
                }
                completionDate={this.state.grading.GradeFeedback.CompletionDate}
              />
            )}
          {this.state.grading.GradeFeedback.GradeOut.length > 0 && (
            <motion.div
              className="newGradingBackWrapper"
              initial={this.props.animationsDisabled ? false : { opacity: 0 }}
              animate={this.props.animationsDisabled ? false : { opacity: 1 }}
              exit={this.props.animationsDisabled ? false : { opacity: 0 }}
              transition={{ duration: 0.2 }}
              key="newGradingBackFooterWrapper"
            >
              <button
                className="tertiaryButton newGradingBackButton"
                onClick={() => this.props.closeGrading()}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="newGradingBackIcon"
                />
                Back To Case List
              </button>
              {this.props.gradingMode !== "peek" &&
                this.state.grading.GradeFeedback.ActionLogList.length > 0 && (
                  <div
                    className="newGradingCheckboxContainer"
                    onClick={this.markHighYieldHandler}
                    style={{
                      gridTemplateColumns: "30px auto auto",
                      paddingRight: "10px",
                    }}
                  >
                    <div className="newGradingCheckbox">
                      {this.state.highYield && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="newGradingCheckboxIcon"
                        />
                      )}
                    </div>
                    <p className="newGradingCheckboxText">High Yield</p>
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="highYieldMoreInfoButton"
                      onClick={this.highYieldHelpHandler}
                    />
                    {this.state.highYieldLoading && (
                      <div className="highYieldLoadingContainer">
                        <MDSpinner size={35} singleColor={"#fff"} />
                      </div>
                    )}
                  </div>
                )}
              <div
                className="newGradingCheckboxContainer"
                onClick={this.fetchReviewLater}
                style={{ gridTemplateColumns: "30px auto" }}
              >
                <div className="newGradingCheckbox">
                  {this.state.reviewLater && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="newGradingCheckboxIcon"
                    />
                  )}
                </div>
                <p className="newGradingCheckboxText">Review Later</p>
                {this.state.reviewLaterLoading && (
                  <div className="highYieldLoadingContainer">
                    <MDSpinner size={30} singleColor={"#fff"} />
                  </div>
                )}
              </div>
            </motion.div>
          )}
          <AnimatePresence>
            {this.state.showFeedbackModal && (
              <motion.div
                className="feedbackModalOverlay"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                onClick={this.closeFeedbackModal}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}
              >
                <motion.div
                  className="feedbackModalContent"
                  initial={
                    this.props.animationsDisabled
                      ? false
                      : { scale: 0.9, opacity: 0 }
                  }
                  animate={
                    this.props.animationsDisabled
                      ? false
                      : { scale: 1, opacity: 1 }
                  }
                  exit={
                    this.props.animationsDisabled
                      ? false
                      : { scale: 0.9, opacity: 0 }
                  }
                  transition={{ duration: 0.2 }}
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    backgroundColor:
                      this.props.selectedTheme?.secondaryBackgroundColor ||
                      "#fff",
                    borderRadius: "12px",
                    padding: "24px",
                    width: "90%",
                    maxWidth: "500px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                  }}
                >
                  <h2
                    style={{
                      margin: "0 0 16px 0",
                      color:
                        this.props.selectedTheme?.primaryTextColor || "#333",
                    }}
                  >
                    Send Feedback
                  </h2>
                  {this.state.feedbackSubmitted ? (
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                      <FontAwesomeIcon
                        icon={faCheck}
                        style={{
                          fontSize: "48px",
                          color: "#4CAF50",
                          marginBottom: "16px",
                        }}
                      />
                      <p
                        style={{
                          color:
                            this.props.selectedTheme?.primaryTextColor ||
                            "#333",
                          fontSize: "16px",
                        }}
                      >
                        Thank you for your feedback!
                      </p>
                    </div>
                  ) : (
                    <>
                      <textarea
                        value={this.state.feedbackText}
                        onChange={(e) =>
                          this.setState({ feedbackText: e.target.value })
                        }
                        placeholder="Share your thoughts, suggestions, or report issues..."
                        style={{
                          width: "100%",
                          minHeight: "120px",
                          padding: "12px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                          fontSize: "14px",
                          resize: "vertical",
                          boxSizing: "border-box",
                          fontFamily: "inherit",
                        }}
                      />
                      {this.state.feedbackError && (
                        <p
                          style={{
                            color: "#f44336",
                            fontSize: "14px",
                            margin: "8px 0 0 0",
                          }}
                        >
                          {this.state.feedbackError}
                        </p>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "12px",
                          marginTop: "16px",
                        }}
                      >
                        <button
                          className="tertiaryButton"
                          onClick={this.closeFeedbackModal}
                          style={{ padding: "10px 20px" }}
                        >
                          Cancel
                        </button>
                        <button
                          className="tertiaryButton"
                          onClick={this.submitFeedback}
                          disabled={
                            this.state.feedbackLoading ||
                            !this.state.feedbackText.trim()
                          }
                          style={{
                            padding: "10px 20px",
                            opacity:
                              this.state.feedbackLoading ||
                              !this.state.feedbackText.trim()
                                ? 0.6
                                : 1,
                          }}
                        >
                          {this.state.feedbackLoading ? (
                            <MDSpinner size={16} singleColor={"#fff"} />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
          <AnimatePresence>
            {this.state.viewPreviousCompletions && (
              <ViewCompletionsPopup
                closePopup={() =>
                  this.setState({ viewPreviousCompletions: false })
                }
                previousCompletionSelected={
                  this.state.previousCompletionSelected
                }
                previousCompletions={this.state.previousCompletions}
                updatePreviousCompletionSelected={(newSelection) =>
                  this.setState({
                    previousCompletionSelected: newSelection,
                  })
                }
                confirm={(caseId) => this.fetchRetrieveCaseGrade(caseId)}
                timeZone={this.props.userData.TimeZone}
                primaryColor={this.props.primaryColor}
                key="viewCompletionsPopupComponent"
              />
            )}
          </AnimatePresence>
        </AnimatePresence>
      </div>
    );
  }
}
